import Keycloak from 'keycloak-js';
import {apiEndpoint} from '../utilities/api';
import {authenticate} from './legacy';

const USER_STORAGE_KEY = 'apiuser';
const TOKEN_STORAGE_KEY = 'plato-js-client:token';

export const keycloak = new Keycloak({
    realm: process.env.REACT_APP_KEYCLOAK_REALM,
    url: process.env.REACT_APP_KEYCLOAK_HOST,
    clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID,
});

const AUTH_MODE_STORAGE_KEY = 'plato-js-client:auth-mode';
const AUTH_MODE_KEYCLOAK = 'keycloak';
const AUTH_MODE_LEGACY = 'legacy';

/** @deprecated */
export const setKeycloakAuthMode = (useKeycloak) => {
    try {
        localStorage.setItem(AUTH_MODE_STORAGE_KEY, useKeycloak ? AUTH_MODE_KEYCLOAK : AUTH_MODE_LEGACY);
    } catch (e) {
    }
};

/** @deprecated */
export const isUsingKeycloak = () => {
    try {
        return localStorage.getItem(AUTH_MODE_STORAGE_KEY) === AUTH_MODE_KEYCLOAK;
    } catch (e) {
        return false;
    }
};

/** @deprecated: Only used for legacy authentication */
export const clearTokenStorage = () => {
    localStorage.removeItem(TOKEN_STORAGE_KEY);
    localStorage.loginRequired = true;

    clearUserStorage();

};

export const clearUserStorage = () => {
    localStorage.removeItem(USER_STORAGE_KEY);
}

/** @deprecated: Only used for legacy authentication */
export const storeAccessToken = (accessToken, refreshToken = undefined) => {
    localStorage.setItem(TOKEN_STORAGE_KEY, accessToken);
    localStorage.setItem('refresh_token', refreshToken);
    localStorage.loginRequired = false;
};

let ongoingSessionRefreshPromise = null;

const refreshKeycloakSession = () => {
    if (null === ongoingSessionRefreshPromise) {
        // See if we've still got refresh token to exchange, if the session has ended
        // we'll have to redirect the user to login again.
        ongoingSessionRefreshPromise = keycloak
            .updateToken(-1)
            .then(() => true)
            .catch(() => {
                login({
                    redirectUri: window.location.href,
                });
                return false;
            })
            .finally(() => {
                ongoingSessionRefreshPromise = null;
            });
    }

    return ongoingSessionRefreshPromise;
};

export async function login(options) {
    return keycloak.login(options);
}

export async function logout(options) {
    return keycloak.logout({
        ...options,
        logoutMethod: 'POST'
    });
}

export const readAccessToken = async () => {
    if (!isUsingKeycloak()) {
        return localStorage.getItem(TOKEN_STORAGE_KEY);
    }

    try {
        // If the access token is about to expire, exchange the refresh token for a new one.
        // Though this may now work when: the session ended, JWT is refused by the reverse proxy.
        await keycloak.updateToken(10);
    } catch (e) {
        // Ignore errors.
    }

    return keycloak.token;
};

export const readCachedUser = () => {
    try {
        const cachedUser = JSON.parse(localStorage.getItem(USER_STORAGE_KEY));
        if (cachedUser) {
            return cachedUser;
        }
    } catch (error) {
        return undefined;
    }
    return undefined;
};

export const cacheUser = (user) => {
    localStorage.setItem(
        USER_STORAGE_KEY,
        JSON.stringify(user),
    );
};

export const tryReauthenticatingExpiredSession = async () => {
    if (!isUsingKeycloak()) {
        try {
            const accessToken = await readAccessToken();
            const response = await fetch(apiEndpoint('/v2/whoami'), {
                headers: {
                    'Authorization': `Bearer ${ accessToken }`,
                },
            });

            if (200 === response.status) {
                // Still authenticated. Carry on.
                return true;
            }

            const authenticated = await authenticate(undefined, undefined);
            if (authenticated) {
                // We refreshed the session. Let the caller try again.
                return true;
            }

            clearTokenStorage();
            window.location.replace(`${ window.location.origin }/login`);

            return false;
        } catch (e) {
            // This could happen for HTTP 403, or server errors.
            return false;
        }
    }

    return refreshKeycloakSession();
}
